import { render } from "./AgreementModal.vue?vue&type=template&id=b5a47d4e&scoped=true"
import script from "./AgreementModal.vue?vue&type=script&lang=js"
export * from "./AgreementModal.vue?vue&type=script&lang=js"

import "./AgreementModal.vue?vue&type=style&index=0&id=b5a47d4e&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a47d4e"]])

export default __exports__